import React, { useEffect, useState } from "react";
import { Img } from "../shared/img";
//import useIsMobile from "../../js/utilities/useIsMobile";

export const AwardAasl1 = ({ page }) => {
    // const isMobile = useIsMobile();
    const corte = page === "home" ? 1200 : 1450;
    const [isMobile, setIsMobile] = useState(window.innerWidth < corte ? true : false);
    useEffect(() => {
        const setMobile = () => {
            let validacion;
            if (window.innerWidth < corte) {
                validacion = true;
            } else {
                validacion = false;
            }
            setIsMobile(validacion)
        }
        setMobile();
        window.addEventListener('resize', setMobile)
        return () => {
            window.removeEventListener('resize', setMobile)
        }
    }, [page])

    return (
        <div className="">
            <div className={`award-aasl ${page}`}>
                <a
                    href="https://www.ala.org/news/2026/05/aasl-announces-2026-best-digital-tools-teaching-learning"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="focusable-red logo"
                >
                    {
                        isMobile ?
                            <Img
                                alt=""
                                aria-hidden={true}
                                className='img-fluid'
                                src="/img/awards/aasl-digital-tools2.png"
                            />
                            :
                            <Img
                                alt=""
                                aria-hidden={true}
                                className='img-fluid'
                                src="/img/awards/aasl-digital.png"
                            />
                    }
                </a>
            </div>

        </div>
    )
}